import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService

    ) { }

    ngOnInit() {
      this.titleService.setTitle('Verificador gramatical profissional com aprimoramentos contextuais em inglês - Trinka');
      this.metaTagService.updateTag({ name: 'description', content: 'A Trinka é um verificador gramatical online para redação acadêmica e técnica. Saiba mais sobre como chegamos aqui e o que está por vir.' });
      this.metaTagService.updateTag({ property: 'og:title', content: 'Verificador de gramática on-line' });
      this.metaTagService.updateTag({ property: 'og:description', content: 'Torne a sua escrita mais avançada e técnica com a ajuda da Trinka. Impressione seus leitores com linguagem ousada e precisa, tornando sua escrita fácil de entender.' });
      this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/pt/aboutus' });
      this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
      this.metaTagService.updateTag({ name: 'language', content: 'pt-pt' });
      this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/pt/aboutus' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/aboutus'});
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/aboutus'});
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/aboutus' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/aboutus' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/aboutus' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/aboutus' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/aboutus' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/aboutus' });
      if (isPlatformBrowser(this.platformId)){
        $.getScript('../../../assets/js/owl.carousel.min.js', function () { });
        $.getScript('../../../assets/js/about_us_testimonial_silders.js', function () { });
        $.getScript('../../../assets/js/wisepop.js', function(){});
      }
      ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()})
    }
    ngAfterViewInit(){
      if (isPlatformBrowser(this.platformId)){
        $.getScript('../../../assets/js/branding_logo.js', function () { });
      }
    }

    generateGuid() {
      var result, i, j;
      result = '';
      for(j=0; j<32; j++) {
        if( j == 8 || j == 12 || j == 16 || j == 20)
          result = result + '-';
        i = Math.floor(Math.random()*16).toString(16).toUpperCase();
        result = result + i;
      }
      return result;
    }

}
